import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';

@Component({
  selector: 'app-store-services',
  templateUrl: './store-services.component.html',
  styleUrls: ['./store-services.component.css'],
})
export class StoreServicesComponent implements OnInit {
  tabitems: any = [];

  deliveryDays = [
    { label: 'Today only', value: '1' },
    { label: 'Today and Tomorrow', value: '2' },
    { label: 'Today + 2 days', value: '3' },
    { label: 'Today + 3 days', value: '4' },
    { label: 'Today + 4 days', value: '5' },
    { label: 'Today + 5 days', value: '6' },
    { label: 'Today + 6 days', value: '7' },
  ];

  storeId: any;
  selectedStore: any;
  cookieStore: any;
  storeConfigForm: FormGroup;
  hasConfig = false;
  selectedStoreConfig = {
    collectionTimeIncrements: 0,
    collectionCharge: 0,
    collectionStartInterval: 0,
    notificationEmail: '',
    deliveryOrders: false,
    deliveryRadiusMiles: 0,
    deliveryCost: 0,
    deliveryMinAmount: 0,
    deliveryTimeIncrements: 0,
    deliveryStartInterval: 0,
    deliveryZone2Radius: 0,
    deliveryZone2Cost: 0,
    deliveryFreeAmount: 0,
    maxSlotsDeliveryIncrement: 0,
    numberOfDeliveryDays: 0,
    groupOrders: false,
    instoreOrders: false,
    prepayOrders: false,
    kioskOrders: false,
    foodToGo: false,
    grocery: false
  };

  role: any;
  routeRole: any;

  constructor(
    public fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public loader: LoadingBarService,
    public notificationService: NotificationService,
    public globals: Globals,
    public cookieService: CookieService,
    public router: Router,
    public _storeService: StoreService
  ) {
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
    } else {
      this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
    }

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    this.tabitems = [
      { path: '/' + this.routeRole + '/store/details', title: 'Details' },
      { path: '/' + this.routeRole + '/store/location', title: 'Location' },
      { path: '/' + this.routeRole + '/store/opening-times', title: 'Ordering Times' },
      { path: '/' + this.routeRole + '/store/media', title: 'Media' },
      { path: '/' + this.routeRole + '/store/payment-setup', title: 'Payment Setup' },
      { path: '/' + this.routeRole + '/store/pos-setup', title: 'POS Setup' },
      { path: '/' + this.routeRole + '/store/services', title: 'Services' },
    ];

    this.storeConfigForm = fb.group({
      collectionTimeIncrements: new FormControl(),
      collectionCharge: new FormControl(),
      deliveryOrders: new FormControl(false),
      deliveryRadiusMiles: new FormControl(),
      deliveryTimeIncrements: new FormControl(),
      groupOrders: new FormControl(false),
      instoreOrders: new FormControl(false),
      prepayOrders: new FormControl(false),
      kioskOrders: new FormControl(false),
      foodToGo: new FormControl(false),
      grocery: new FormControl(false),
    });
  }

  ngOnInit() {
    this.getStore(this.storeId);
  }

  // Get Store by id
  public getStore(id) {
    this._storeService.getStoreById(id).subscribe(
      (data: any) => {
        console.log('Selected Store -> ', data);
        this.selectedStore = data;
        if (data.storeConfig !== null) {
          this.hasConfig = true;
          this.selectedStoreConfig = {
            collectionTimeIncrements: data.storeConfig.collectionTimeIncrements,
            deliveryOrders: data.storeConfig.deliveryOrders,
            deliveryRadiusMiles: data.storeConfig.deliveryRadiusMiles,
            deliveryCost: data.storeConfig.deliveryCost,
            deliveryMinAmount: data.storeConfig.deliveryMinAmount,
            deliveryTimeIncrements: data.storeConfig.deliveryTimeIncrements,
            groupOrders: data.storeConfig.groupOrders,
            instoreOrders: data.storeConfig.instoreOrders,
            deliveryStartInterval: data.storeConfig.deliveryStartInterval,
            deliveryZone2Radius: data.storeConfig.deliveryZone2Radius,
            deliveryZone2Cost: data.storeConfig.deliveryZone2Cost,
            deliveryFreeAmount: data.storeConfig.deliveryFreeAmount,
            maxSlotsDeliveryIncrement: data.storeConfig.maxSlotsDeliveryIncrement,
            numberOfDeliveryDays: data.storeConfig.numberOfDeliveryDays,
            prepayOrders: data.storeConfig.prepayOrders,
            kioskOrders: data.storeConfig.kioskOrders,
            collectionCharge: data.storeConfig.collectionCharge,
            collectionStartInterval: data.storeConfig.collectionStartInterval,
            notificationEmail: data.storeConfig.notificationEmail,
            foodToGo: data.storeConfig.foodToGo,
            grocery: data.storeConfig.grocery
          };
        } else {
          this.hasConfig = false;
        }
        if (
          data.storeConfig !== null &&
          data.storeConfig.deliveryOrders &&
          this.tabitems.filter((item) => item.title === 'Delivery Times').length === 0
        ) {
          this.tabitems.push({
            path: '/' + this.routeRole + '/store/delivery-times',
            title: 'Delivery Times',
          });
        } else if (
          data.storeConfig !== null &&
          data.storeConfig.deliveryOrders === false &&
          this.tabitems.filter((item) => item.title === 'Delivery Times').length === 1
        ) {
          this.tabitems.splice(
            this.tabitems.findIndex((item) => item.title === 'Delivery Times'),
            1
          );
        }
        if (
          data.storeConfig !== null &&
          data.storeConfig.kioskOrders &&
          this.tabitems.filter((item) => item.title === 'Kiosks').length === 0
        ) {
          this.tabitems.push({ path: '/' + this.routeRole + '/store/kiosks', title: 'Kiosks' });
        } else if (
          data.storeConfig !== null &&
          data.storeConfig.kioskOrders === false &&
          this.tabitems.filter((item) => item.title === 'Kiosks').length === 1
        ) {
          this.tabitems.splice(
            this.tabitems.findIndex((item) => item.title === 'Kiosks'),
            1
          );
        }
      },
      (err) => {
        console.log('Getting store by ID error, navigate to select store');
        this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
      }
    );
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  public submitStoreConfig(config) {
    let emailValid = true;
    if (config.notificationEmail) {
      emailValid = this.validateEmail(config.notificationEmail);
    }

    if (!emailValid) {
      this.notificationService.notify(
        'danger',
        'Store Config Not Saved',
        'Invalid Notificaton Email Address',
        'top',
        'right'
      );
    } else {
      if (this.hasConfig) {
        // edit
        const configBody = {
          collectionTimeIncrements: config.collectionTimeIncrements,
          deliveryOrders: config.deliveryOrders,
          deliveryRadiusMiles: config.deliveryRadiusMiles,
          deliveryCost: config.deliveryCost,
          deliveryTimeIncrements: config.deliveryTimeIncrements,
          deliveryMinAmount: config.deliveryMinAmount,
          deliveryStartInterval: config.deliveryStartInterval,
          deliveryZone2Radius: config.deliveryZone2Radius,
          deliveryZone2Cost: config.deliveryZone2Cost,
          deliveryFreeAmount: config.deliveryFreeAmount,
          maxSlotsDeliveryIncrement: config.maxSlotsDeliveryIncrement,
          numberOfDeliveryDays: config.numberOfDeliveryDays,
          groupOrders: config.groupOrders,
          instoreOrders: config.instoreOrders,
          prepayOrders: config.prepayOrders,
          kioskOrders: config.kioskOrders,
          foodToGo: config.foodToGo,
          grocery: config.grocery,
          collectionCharge: config.collectionCharge,
          notificationEmail: config.notificationEmail,
          collectionStartInterval: config.collectionStartInterval,
          id: this.selectedStore.storeConfig.id,

        };
        this._storeService.editStoreConfig(configBody).subscribe((data: any) => {
          // console.log(data);
          this.getStore(this.storeId);
          this.notificationService.notify(
            'success',
            'Store Config Updated',
            'Store Config successfully updated',
            'top',
            'right'
          );
        });
      } else {
        // Create Config
        const configBody = {
          collectionTimeIncrements: config.collectionTimeIncrements,
          deliveryOrders: config.deliveryOrders,
          deliveryRadiusMiles: config.deliveryRadiusMiles,
          deliveryTimeIncrements: config.deliveryTimeIncrements,
          groupOrders: config.groupOrders,
          instoreOrders: config.instoreOrders,
          prepayOrders: config.prepayOrders,
          kioskOrders: config.kioskOrders,
          foodToGo: config.foodToGo,
          grocery: config.grocery,
          collectionCharge: config.collectionCharge,
          notificationEmail: config.notificationEmail,
          storeId: this.storeId,
        };
        this._storeService.createStoreConfig(configBody).subscribe((data: any) => {
          // console.log(data);
          this.getStore(this.storeId);
          this.notificationService.notify(
            'success',
            'Store Config Created',
            'Store Config successfully created',
            'top',
            'right'
          );
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/indi-store/services/store-services.component.ts